// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { GetHealthData, GetHealthResponses, GetMeData, GetMeResponses, GetReviewsByReviewTypeByIdData, GetReviewsByReviewTypeByIdResponses, GetReviewsByReviewTypeData, GetReviewsByReviewTypeResponses, PostReviewsByReviewTypeAutoData, PostReviewsByReviewTypeAutoResponses, PutReviewsByReviewTypeByIdData, PutReviewsByReviewTypeByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health check endpoint
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/health',
    ...options
});

/**
 * Returns information about the authenticated user
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options
});

/**
 * Returns reviews of the specified type, paginated
 */
export const getReviewsByReviewType = <ThrowOnError extends boolean = false>(options: Options<GetReviewsByReviewTypeData, ThrowOnError>): RequestResult<GetReviewsByReviewTypeResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetReviewsByReviewTypeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewType}',
    ...options
});

/**
 * Automatically creates a new review of the specified type for all items that can be autoReviewed
 */
export const postReviewsByReviewTypeAuto = <ThrowOnError extends boolean = false>(options: Options<PostReviewsByReviewTypeAutoData, ThrowOnError>): RequestResult<PostReviewsByReviewTypeAutoResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostReviewsByReviewTypeAutoResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewType}/auto',
    ...options
});

/**
 * Returns reviews of the specified type
 */
export const getReviewsByReviewTypeById = <ThrowOnError extends boolean = false>(options: Options<GetReviewsByReviewTypeByIdData, ThrowOnError>): RequestResult<GetReviewsByReviewTypeByIdResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetReviewsByReviewTypeByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewType}/{id}',
    ...options
});

/**
 * Creates a new review of the specified type
 */
export const putReviewsByReviewTypeById = <ThrowOnError extends boolean = false>(options: Options<PutReviewsByReviewTypeByIdData, ThrowOnError>): RequestResult<PutReviewsByReviewTypeByIdResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutReviewsByReviewTypeByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/reviews/{reviewType}/{id}',
    ...options
});
